export const CAMERA_TYPE = {
	DEFAULT: 1,
	HIGHLIGHTED_USERS: 2,
};
export const CHAT_EVENTS = {
	DICE_RESULT: 1,
	SHARING: 2,
	CLEAR_DICE_RESULTS: 3,
	USER_NAME: 4,
	CAMERA_LAYOUT: 5,
	SHARE_S3_IMAGE: 6,
	SHARE_S3_AUDIO: 7,
	AVATAR: 8,
	VIDEO_STATUS: 9,
	MIC_STATUS: 10,
	CHAT: 11,
	CHAT_WARNING: 12,
	COUNTDOWN: {
		START: 13,
		END: 14,
	},
	CHARACTER_STATUS: 15,
	KILL: -9,
};
export const CLIENT_EVENTS = {
	ENTER_ROOM: 1,
	SIGNALING: 2,
	STREAM_READY: 3,
	CHAT_READY: 4,
	INCOMING_CHAT: 5,
	ROOM_UPDATE: 6,
	RESYNC_USER: 7,
	DELETE_USER: 8,
};
export const DICE_TYPES = {
	NORMAL: 1,
	L5R: 2,
	RESULT: 3,
	RESULT_SUCCESS: 4,
	RESULT_FAIL: 5,
	CUSTOM: 6,
};
export const FAKE_STREAM = 'fake_stream';
export const COUNTDOWN_CAMERA = 'count_down_camera';
export const IS_LOCALHOST = window.location.hostname === 'localhost';
export const SIZES = {
	small: 24,
	medium: 40,
	big: 100,
};
export const USER_STREAM_STATUS = {
	CREATED: 0,
	SYNC: 1,
	ESTABLISHED: 2,
};

export const IMAGE_MIMES = ['image/jpeg', 'image/png', 'image/jpg'];
export const AUDIO_MIMES = ['audio/mpeg'];

export const LIBRARY_TYPE = {
	PUBLIC: 0,
	PRIVATE: 1,
	RULES: 2,
};

export const LIBRARY_ITEMS_TYPES = {
	FOLDER: 1,
	FILE: 2,
	CREATE_FOLDER: 3,
};

export const EMPTY_LIBRARY = {
	name: '',
	dirty: true,
	type: LIBRARY_ITEMS_TYPES.FOLDER,
	children: [],
};

export const EMPTY_FOLDER = {
	name: '',
	dirty: true,
	children: [],
	type: LIBRARY_ITEMS_TYPES.FOLDER,
};

export const SLEEP = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const USERS = [
	{
		Username: '357946ff-1b25-4588-956e-a20efa2cd12b',
		Attributes: [
			{
				Name: 'sub',
				Value: '357946ff-1b25-4588-956e-a20efa2cd12b',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'dni.lpz1986@gmail.com',
			},
		],
		UserCreateDate: '2021-03-18T17:05:01.360000+00:00',
		UserLastModifiedDate: '2023-05-08T16:17:04.893000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: '5ee0777c-a98a-4f24-b4d8-4d037cf770ac',
		Attributes: [
			{
				Name: 'sub',
				Value: '5ee0777c-a98a-4f24-b4d8-4d037cf770ac',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'alberto.munoz.rodriguez@gmail.com',
			},
		],
		UserCreateDate: '2021-03-02T20:24:12.760000+00:00',
		UserLastModifiedDate: '2021-03-04T16:48:54.805000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: '64486fc9-9da9-4715-a2ab-8cb64683bfec',
		Attributes: [
			{
				Name: 'sub',
				Value: '64486fc9-9da9-4715-a2ab-8cb64683bfec',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'guendor@gmail.com',
			},
		],
		UserCreateDate: '2021-03-03T10:03:18.565000+00:00',
		UserLastModifiedDate: '2021-05-20T15:30:20.900000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: '6d725f21-6ee1-4219-b15f-ed21ba784212',
		Attributes: [
			{
				Name: 'sub',
				Value: '6d725f21-6ee1-4219-b15f-ed21ba784212',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'rbarcena@gmail.com',
			},
		],
		UserCreateDate: '2021-03-11T17:12:56.732000+00:00',
		UserLastModifiedDate: '2022-11-07T17:04:19.589000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: 'b1ac9c10-479d-4b27-9ae3-5000c7a9df30',
		Attributes: [
			{
				Name: 'sub',
				Value: 'b1ac9c10-479d-4b27-9ae3-5000c7a9df30',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'titovampire@gmail.com',
			},
		],
		UserCreateDate: '2020-12-30T11:53:05.733000+00:00',
		UserLastModifiedDate: '2022-06-20T18:12:46.167000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: 'b78030d6-d33e-47cd-9a0e-26165880f84e',
		Attributes: [
			{
				Name: 'sub',
				Value: 'b78030d6-d33e-47cd-9a0e-26165880f84e',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'carrion86@gmail.com',
			},
		],
		UserCreateDate: '2021-03-03T14:45:40.367000+00:00',
		UserLastModifiedDate: '2022-10-17T15:52:53.969000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: 'd5c70d76-221d-4225-a285-c13e1b840578',
		Attributes: [
			{
				Name: 'sub',
				Value: 'd5c70d76-221d-4225-a285-c13e1b840578',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'jose.flydesign@gmail.com',
			},
		],
		UserCreateDate: '2021-03-03T09:34:41.775000+00:00',
		UserLastModifiedDate: '2023-01-16T18:18:47.404000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: '25de558f-b390-4faf-99eb-ea10ea8c7b99',
		Attributes: [
			{
				Name: 'sub',
				Value: '25de558f-b390-4faf-99eb-ea10ea8c7b99',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'bernabeuvolpini@gmail.com',
			},
		],
		UserCreateDate: '2021-03-03T09:34:41.775000+00:00',
		UserLastModifiedDate: '2023-01-16T18:18:47.404000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
	{
		Username: '94ed8fbb-f80a-4024-9d81-c0bffab3d60b',
		Attributes: [
			{
				Name: 'sub',
				Value: '94ed8fbb-f80a-4024-9d81-c0bffab3d60b',
			},
			{
				Name: 'email_verified',
				Value: 'true',
			},
			{
				Name: 'email',
				Value: 'michellejcalleja@gmail.com',
			},
		],
		UserCreateDate: '2021-03-03T09:34:41.775000+00:00',
		UserLastModifiedDate: '2023-01-16T18:18:47.404000+00:00',
		Enabled: true,
		UserStatus: 'CONFIRMED',
	},
];
